import React, { useState, useEffect } from 'react';
import { Box, Grid ,FormControl ,InputLabel ,Select ,MenuItem , Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Input } from '@mui/material';
import HeightBox from '../../../components/HeightBox';
import { useSelector, useDispatch } from 'react-redux';
import { selectFile, deselectFile, setSelectedURLs,selectPassportSizePhoto } from '../../../actions/fileActions';
import { f } from 'html2pdf.js';
import LinearProgress from '@mui/material/LinearProgress';
import api from '../../../api';
const FileList = (props) => {
  

  const [files, setFiles] = useState(props?.files);
  const [selectedFile, setSelectedFile] = useState(null);
  const [token, setToken] = useState('');
  
  const regNumber = useSelector((state) => state.file.selectedRegNumber);
  
  useEffect(() => {
    fetchFiles();
  }, [regNumber]);

  const fetchFiles = async () => {
    console.log(props)
    try {

      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch(`${api}api/v1/candidates/files/${regNumber}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });

      if (response.ok) {
        // Request successful
        const data = await response.json();
        console.log(data);
        setFiles(data);
        console.log(selectedURLs);
        const passportSizeImageFile = data.find(file => file.extraField?.fileName === `${regNumber}passportSizeImage`);
        const certificates1 = data.find(file => file.extraField?.fileName === `${regNumber}certificates1`); 
        // const selectedUrls_ = [certificates1.link];
        // console.log(selectedURLs);

        // setSelectedURLs([certificates1.link,'google.lk'])
        // console.log(certificates1.link)

        // Get the passport size image URL
        const passportSizeImageURL = passportSizeImageFile?.link ?? '';
        // dispatch(setSelectedURLs([certificates1.link,'google.lk']))
        // Store the passport size image URL in state
        dispatch(selectPassportSizePhoto(passportSizeImageURL))
        // Process the response data
      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };

  const deleteFile = async (fileId) => {
    // Display a confirmation dialog to the user
    const confirmDelete = window.confirm("Are you sure you want to delete this file?");
  
    if (!confirmDelete) {
      return; // User cancelled the deletion
    }
  
    setLoading(true);
    try {
      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
  
      await fetch(`${api}api/v1/candidates/files/${fileId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      fetchFiles();
      setLoading(false);
    } catch (error) {
      console.error('Error deleting file:', error);
      setLoading(false);
    }
  };
  

  const updateFile = async (fileId) => {
    try {
      // Your update file logic here
    } catch (error) {
      console.error('Error updating file:', error);
    }
  };
  
  const [loading, setLoading] = useState(false);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const uploadFile = async () => {
    setLoading(true);
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('regNumber', regNumber);
      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const extraField = { fileName: selectedOption,type:'upload',nic:props.nic };

      formData.append('extraField', JSON.stringify(extraField));
      
      try {
        const response = await fetch(`${api}api/v1/candidates/files/${regNumber}`, {
            method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: formData
        });

        if (response.ok) {
          fetchFiles();
          setLoading(false);
        } else {
          console.error('Error uploading file:', response.statusText);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        setLoading(false);
      }
    }
  };

const options = [
  { value: 'passportSizeImage', label: 'Passport Size Image' },
  { value: 'certificates1', label: 'Certificates 1' },
  { value: 'certificates2', label: 'Certificates 2' },
  { value: 'certificates3', label: 'Certificates 3' },
  { value: 'certificates4', label: 'Certificates 4' },
  { value: 'certificates5', label: 'Certificates 5' },
  { value: 'certificates6', label: 'Certificates 6' },
  { value: 'certificates7', label: 'Certificates 7' },
  { value: 'certificates8', label: 'Certificates 8' },
  { value: 'certificates9', label: 'Certificates 9' },
  { value: 'certificates10', label: 'Certificates 10' },
  { value: 'currentPassportCopies', label: 'Current Passport Copy' },
  { value: 'previousPassportCopies1', label: 'Previous Passport Copy 1' },
  { value: 'previousPassportCopies2', label: 'Previous Passport Copy 2' },
  { value: 'previousPassportCopies3', label: 'Previous Passport Copy 3' },
  { value: 'membershipCertificateCopies1', label: 'Membership Certificate Copy 1' },
  { value: 'membershipCertificateCopies2', label: 'Membership Certificate Copy 2' },
  { value: 'membershipCertificateCopies3', label: 'Membership Certificate Copy 3' },
  { value: 'membershipCertificateCopies4', label: 'Membership Certificate Copy 4' },
  { value: 'membershipCertificateCopies5', label: 'Membership Certificate Copy 5' },
  { value: 'workPortfolioCopies1', label: 'Work Portfolio' },
  { value: 'trainingCertificate', label: 'Training Certificate' },
  { value: 'tradeTestCertificate',label: 'Trade Test Certificate' },
  { value: 'previousPaySlips1', label: 'Previous Pay Slips' },
];

const [selectedOption, setSelectedOption] = useState(null);

const handleOptionChange = (option) => {
  setSelectedOption(option.target.value);
  console.log(`Option selected:`, option.target.value);
};

const isUploadDisabled = !selectedOption;

  const previewFile = (fileUrl) => {
    // Open a new window or tab with the file's URL for preview
    window.open(fileUrl, '_blank');
  };

  const selectedRows = useSelector((state) => state.file.selectedRows);
  const selectedURLs = useSelector((state) => state.file.selectedURLs);
  const passportSizePhoto = useSelector((state) => state.file.selectedPassportSizePhoto);

  const dispatch = useDispatch();

  const handleRowSelection = (id, url) => {
    if (selectedRows.includes(id)) {
      dispatch(deselectFile(id));
      const updatedURLs = selectedURLs.filter((_, index) => selectedRows[index] !== id);
      dispatch(setSelectedURLs(updatedURLs));
    } else {
      dispatch(selectFile(id));
      const updatedURLs = [...selectedURLs, url];
      dispatch(setSelectedURLs(updatedURLs));
    }
  };

  return (
    <TableContainer component={Paper}>
      <HeightBox height={20}/>

      <HeightBox height={20}/>
      {props.viewOnly !== 'true' && (
      <Grid container spacing={2} alignItems="center">
      <Grid item xs={6}>
     
             <FormControl fullWidth
             size='small'
             >
               <InputLabel>Select File Name</InputLabel>
               <Select value={selectedOption} onChange={handleOptionChange}>
                 <MenuItem value="">
                   <em>Select File Name</em>
                 </MenuItem>
                 {options.map((option) => (
                   <MenuItem key={option.value} value={option.value}>
                     {option.label}
                   </MenuItem>
                 ))}
               </Select>
             </FormControl>
         
       
      </Grid>
      <Grid item xs={4}>
        <Input type="file" onChange={handleFileSelect} />
      </Grid>
      <Grid item xs={2}>
        <Button variant="contained" color="primary" onClick={uploadFile} disabled={isUploadDisabled}>
          Upload
        </Button>
      </Grid>
      </Grid>
      )}

    <HeightBox height={20}/>


      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Registration Number</TableCell>
            <TableCell>File Name</TableCell>
            <TableCell>Preview</TableCell>
            {props.viewOnly !== 'true' && 
              <TableCell>Actions</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
        {files?.map((file) => (
          <TableRow key={file?.id}>
            <TableCell>{file?.regNumber}</TableCell>
            <TableCell>{file?.extraField?.fileName}</TableCell>
            <TableCell>
              <Button variant="outlined" color="primary" onClick={() => previewFile(file.link)}>
                Preview
              </Button>
            </TableCell>
            {props.viewOnly!=='true' &&           
            <TableCell>
              <Button variant="outlined" color="secondary" onClick={() => deleteFile(file.id)}>
                Delete
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => handleRowSelection(file.id, file.link)}
              >
                {selectedRows.includes(file.id) ? 'Selected' : 'Select'}
              </Button>
            </TableCell>
            }
          </TableRow>
        ))}

        </TableBody>
      </Table>
      {loading && 
            <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
      }
    </TableContainer>
  );
};

export default FileList;
